import React, { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import Immutable from "immutable";
import deepmerge from "deepmerge";
import { t } from "i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import Alert from "react-bootstrap/Alert";
import update from "immutability-helper";
import objectPath from "object-path";
import { Utils } from "@qjumpers/common-ui";
import { StepperComp as Stepper, StepComp as Step, ReviewComp as Review, pathWidgets } from "@qjumpers/common-ui";
import { getDefaultFormState } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import {
  customWidgetsComp as commonCustomWidgets,
  IntlFieldTemplateComp as IntlFieldTemplate,
  Loading,
  NavigationPrompt,
} from "@qjumpers/common-ui";
import CustomTextareaWidget from "../../FormComponents/Widgets/CustomTextareaWidget";
import CustomTextWidget from "../../FormComponents/Widgets/CustomTextWidget";
import CustomSkillsWidget from "../../FormComponents/Widgets/CustomSkillsWidget";
import { customFields } from "../../../FormComponents/Fields";


import { createEnumItemsDefinition } from "../utils";
import { candidateId as candidateIdAtom } from "../../../recoil/candidate/atom";
import { jobTypesData } from "../../../recoil/jobTypes/atom";
import { jobStatusData } from "../../../recoil/jobStatus/atom";
import { occupationsData } from "../../../recoil/occupations/atom";
import schemaJson from "./schema.json";
import uiSchema1 from "./uiSchema/1.json";
import uiSchema2 from "./uiSchema/2.json";
import uiSchema3 from "./uiSchema/3.json";
import uiSchema4 from "./uiSchema/4.json";
import uiSchema5 from "./uiSchema/5.json";
import {
  getCurrentCandidate,
  getCurrentCandidateDocumentStatus,
  putCurrentCandidate,
} from "../../../requests/candidates";
import { toastMessageState } from "../../../recoil/toast/atom";
import { errorState } from "../../../recoil/error/atom";
import styles from "./ProfileForm.module.scss";
import { cvParsingResponse } from "../../../recoil/cvparsing/atom";
import { setParsedAddress, setCountryValidation } from "../ApplicationForm/applicationHelpers";
import { clone } from "lodash";

const customWidgets = {
  ...commonCustomWidgets,
  textarea: CustomTextareaWidget,
  TextareaWidget: CustomTextareaWidget,
  text: CustomTextWidget,
  TextWidget: CustomTextWidget,
  EmailWidget: CustomTextWidget,
  customTextWidget: CustomTextWidget,
  customSkillsWidget: CustomSkillsWidget,
};

const ProfileForm = (props) => {
  const jobTypes = useRecoilValue(jobTypesData);
  const jobStatuses = useRecoilValue(jobStatusData);
  const occupations = useRecoilValue(occupationsData);
  const popToast = useSetRecoilState(toastMessageState);
  const popError = useSetRecoilState(errorState);
  const getCvParsingResponseData = useRecoilValue(cvParsingResponse);

  const [alert, setAlert] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [alertTitle, setAlertTitle] = useState();
  //const [externalUserId, setExternalUserId] = useState("");
  const [formData, setFormData] = useState({});
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pristine, setPristine] = useState(true);
  const [schema, setSchema] = useState(schemaJson);
  const [showAlert, setShowAlert] = useState("");
  const [stepNavigation, setStepNavigation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [checksum, setChecksum] = useState();
  const candidateId = useRecoilValue(candidateIdAtom);

  useEffect(() => {
    if (jobTypes != null && jobStatuses != null && occupations && candidateId != null) {
      initialise();
      getCurrentCandidate().then((result) => {
        if (result.data) {
          if (result.data.skills == null || /^(""|''|)$/.test(result.data.skills)) {
            result.data.skills = "";
          }
          // Skills value is kept as-is (JSON stringified array) for the CustomSkillsWidget
          if (!result.data.address) {
            result.data.address = {};
            result.data.address.countryCode = "NZ";
          }

          if (result.data.cv && !result.data.cv.upload) {
            result.data.cv.upload = result.data.cv.id;
          }
          setFormData(result.data);
          setInit(true);

          setLoading(false);
        } else {
          popToast([]);
        }
      });

      getCurrentCandidateDocumentStatus().then((result) => {
        if (result.data) {
          setShowAlert(result.data);
        }
      });
    }
  }, [jobTypes, jobStatuses, occupations, candidateId]);

  useEffect(() => {
    if (getCvParsingResponseData?.data) {
      let parsedCvResponse = clone(getCvParsingResponseData.data);
      let parsedAddress = null;
      let newProps = [];
      const keys = [
        "primaryContactNumber",
        "secondaryContactNumber",
        "executiveSummary",
        "employment",
        "qualification",
        "referee",
        "address",
        "skills",
      ];

      if (
        parsedCvResponse !== null &&
        (parsedCvResponse.skills == null || typeof parsedCvResponse.skills === "undefined")
      ) {
        parsedCvResponse["skills"] = JSON.stringify([]);
      }
      keys.forEach((key) => {
        const existing = objectPath.get(formData, key);

        if (key === "address" && parsedCvResponse.address) {
          parsedAddress = parsedCvResponse.address;
        }
        const newValue = objectPath.get(parsedCvResponse, key);
        newProps.push(Utils.getPatch(key, existing && existing.length ? existing : newValue));
      });
      const newFormData = update(formData, deepmerge.all(newProps));
      newFormData.address = setParsedAddress(parsedAddress, newFormData.address);
      setFormData(newFormData);
      setChecksum(new Date().getTime());
    }
  }, [getCvParsingResponseData]);

  const initialise = () => {
    const jobTypesSchema = createEnumItemsDefinition("jobTypes", jobTypes ? jobTypes : []);
    const jobStatusSchema = createEnumItemsDefinition("jobStatus", jobStatuses ? jobStatuses : []);
    const occupationsSchema = createEnumItemsDefinition("occupations", occupations ? occupations : [], "label");

    let newSchema = Immutable.fromJS(schema)
      .set("definitions", {
        ...schema.definitions,
        ...jobTypesSchema,
        ...jobStatusSchema,
        ...occupationsSchema,
      })
      .toJS();

    let formDataUpdated = getDefaultFormState(newSchema, formData, newSchema.definitions);

    setFormData(formDataUpdated);
    setSchema(newSchema);
  };
  const navigateBack = () => {
    window.history.back();
  };

  const onFormStop = () => {
    setAlert(false);
    setAlertError(false);
    navigateBack();
  };

  const onForceStop = () => {
    setAlert(false);
    setAlertError(false);
    navigateBack();
  };

  // Using imported setCountryValidation

  const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

  const onFormDataChange = ({ formData: formDataInput }) => {
    const updatedFormData = deepmerge.all([formData, formDataInput], { arrayMerge: overwriteMerge });

    if (formDataInput.qualification) {
      updatedFormData.qualification = formDataInput.qualification;
    }
    if (formDataInput.referee) {
      updatedFormData.referee = formDataInput.referee;
    }
    if (formDataInput.employment) {
      updatedFormData.employment = formDataInput.employment;
    }
    if (formDataInput.jobStatusPreferences) {
      updatedFormData.jobStatusPreferences = formDataInput.jobStatusPreferences;
    }
    if (formDataInput.jobTypePreferences) {
      updatedFormData.jobTypePreferences = formDataInput.jobTypePreferences;
    }
    if (formDataInput.occupationPreferences) {
      updatedFormData.occupationPreferences = formDataInput.occupationPreferences;
    }
    if (formDataInput.locationPreferences) {
      updatedFormData.locationPreferences = formDataInput.locationPreferences;
    }
    // if (formData.cv === null) {
    //   updatedFormData.cv = this.initialiseCV();
    // }
    // deep copy
    let newSchema = JSON.parse(JSON.stringify(schema));
    let countryValidation = setCountryValidation(newSchema, updatedFormData);

    setFormData(countryValidation.formData);
    setPristine(false);
    setSchema(countryValidation.schema);
    setChecksum(new Date().getTime());
  };

  const formPause = () => {
    setSubmitting(true);
    setPristine(true);
    setChecksum(new Date().getTime());
  };

  const formPlay = (pristine = false) => {
    setSubmitting(false);
    setPristine(pristine);
    setChecksum(new Date().getTime());
  };

  const enableStepNavigation = () => {
    // if step past the last required form
    setStepNavigation(true);
  };

  const beforeSubmit = () => {
    popError([
      {
        type: "warning",
        title: t("Form.Candidate.Confirm.Title"),
        message: t("Form.Candidate.SubmitConfirmation"),
        confirmBtnText: t("Action.Submit"),
        showCancel: true,
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "default",
        onConfirm: onSubmit,
      },
    ]);
  };

  const onSubmit = () => {
    formPause();
    // DEL Empty Document
    if (formData.cv && !formData.cv.upload) {
      delete formData.cv;
    }
    if (formData.cv && formData.cv.upload && formData.cv.upload == formData.cv.id) {
      formData.cv.upload = null;
    }
    // DEL Empty Document
    if (formData.coverLetter && !formData.coverLetter.upload) {
      delete formData.coverLetter;
    }

    if (formData.address && !formData.address.countryCode) {
      delete formData.address;
    }

    if (formData.skills === "" || formData.skills === "undefined") {
      formData.skills = "[]";
    } else {
      try {
        JSON.parse(formData.skills);
      } catch (e) {
        formData.skills = JSON.stringify(formData.skills);
      }
    }

    putCurrentCandidate(formData)
      .then(() => {
        popToast([
          {
            type: "success",
            title: t("Profile.saved"),
          },
        ]);
        window.location = `http://${window.location.host}`;
      })
      .catch(() => formPlay());
  };

  const hideAlert = () => {
    setAlert(false);
  };

  const hideAlertError = () => {
    setAlertError(false);
    setAlertMessage("");
    setAlertTitle("");
  };

  const validatePayRange = (formDataInput, errors) => {
    return errors;
  };

  if (!init) {
    return <Loading className="loading-component" />;
  }
  let allUiSchemas = [uiSchema1, uiSchema2, uiSchema3, uiSchema4, uiSchema5];
  let steps = [
    {
      name: "Form.Application.PersonalDetails",
      title: "Form.Application.PersonalDetails",
      icon: "qjicon-profile",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema1}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
        />
      ),
    },
    {
      name: "Form.Application.GeneralInfo",
      title: "Form.Application.GeneralInfo",
      icon: "qjicon-suitcase",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema2}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
        />
      ),
    },
    {
      name: "Form.Application.Qualifications",
      title: "Form.Application.Qualifications",
      icon: "qjicon-bars",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema3}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
        />
      ),
    },
    {
      name: "Form.Application.Employments",
      title: "Form.Application.Employments",
      icon: "qjicon-star",
      component: (
        <Step
          schema={schema}
          uiSchema={uiSchema4}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
        />
      ),
    },
    {
      name: "Form.Application.Preferences",
      title: "Form.Application.Preferences",
      icon: "qjicon-star",
      component: (
        <Step
          customValidate={validatePayRange}
          schema={schema}
          uiSchema={uiSchema5}
          onUpdate={onFormDataChange}
          noValidate={true}
          fields={customFields}
          widgets={customWidgets}
          FieldTemplate={IntlFieldTemplate}
        />
      ),
    },
  ];

  steps.push({
    name: "Form.Review.Tab",
    title: "Form.Review.Title",
    icon: "qjicon-tick",
    component: (
      <Review
        schema={schema}
        uiSchema={allUiSchemas}
        fields={customFields}
        widgets={customWidgets}
        FieldTemplate={IntlFieldTemplate}
        validateAllSteps={true}
      />
    ),
  });

  return (
    <div>
      {showAlert && (
        <div className="row">
          <Alert variant="warning">
            <center>
              <strong>{t("AgreementDocuments.pendingSignatureErrorMessage")}</strong>
            </center>
          </Alert>
        </div>
      )}
      {submitting ? (
        <div className="formLoader">
          <Loading className="loading-component" />
        </div>
      ) : null}

      <NavigationPrompt when={!pristine} />

      <div className="job-detail">
        <div className={styles.profileForm}>
          <div>
            <div className="row">
              <div className="stepperForm">
                {loading ? (
                  <div className="formLoader">
                    <Loading className="loading-component" />
                  </div>
                ) : (
                  <Stepper
                    checksum={checksum}
                    preventEnterSubmission={true}
                    steps={steps}
                    prevBtnOnLastStep={true}
                    dontValidate={false}
                    formData={JSON.parse(JSON.stringify(formData))}
                    alwaysUpdate={true}
                    stepsNavigation={stepNavigation}
                    reviewSteps={true}
                    pristine={pristine}
                    showErrorList={true}
                    enableStepNavigation={enableStepNavigation}
                    onStepChange={() => { }}
                    popError={() =>
                      popError([
                        {
                          type: "warning",
                          title: t("Form.Errors.Title"),
                          message: t("Form.Errors.PleaseCorrect"),
                          confirmBtnText: t("Action.Ok"),
                          confirmBtnBsStyle: "danger",
                          cancelBtnBsStyle: "default",
                        },
                      ])
                    }
                    actions={[
                      {
                        title: t("Action.Save"),
                        className: "btn btn-primary btn-lg",
                        validate: true,
                        onClick: beforeSubmit,
                        disabled: submitting,
                      },
                      {
                        title: t("Action.Cancel"),
                        className: "btn btn-border btn-lg",
                        validate: false,
                        onClick: onFormStop,
                      },
                    ]}
                  />
                )}

                {alert ? (
                  <SweetAlert
                    warning
                    showCancel
                    confirmBtnText={t("Modal.Unsaved.Leave")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={t("Form.Unsaved.Title")}
                    onConfirm={onForceStop}
                    onCancel={hideAlert}>
                    {t("Alert.LoseChangesWarning")}
                  </SweetAlert>
                ) : null}
                {alertError ? (
                  <SweetAlert
                    warning
                    confirmBtnText={t("Modal.Close")}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={alertTitle}
                    onConfirm={hideAlertError}>
                    {alertMessage}
                  </SweetAlert>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;
